import { render, staticRenderFns } from "./create-report.vue?vue&type=template&id=b672f6f0"
import script from "./create-report.vue?vue&type=script&lang=js"
export * from "./create-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports